import Observer from 'common/scripts/observer';
import Popup from 'components/popup';
import PopupVideoControls from 'components/online';
import ShowMore from 'components/show-more';
import Slider from 'components/slider';

const observer = new Observer();
const progressPopupBtn = Array.from(document.querySelectorAll('.j-progress-popup'));

// Поключаем слайдер в попапе с ходом строительства
observer.subscribe('insetContentPopup', (openPopup) => {
    const sliderProgressWrap = openPopup.querySelector('.j-progress-slider');

    if (sliderProgressWrap) {
        const sliderProgress = new Slider();

        sliderProgress.init({
            slider       : sliderProgressWrap,
            dots         : true,
            thumbnails   : false,
            arrow        : true,
            counter      : true,
            arrowPosition: 'caption',
            caption      : true,
            modify       : 'theme_progress'
        });
    }
});

const initProgressPopup = (buttons) => {
    if (buttons) {
        const popupOptions = {
            openButtons         : buttons,
            closeButtonAriaLabel: 'Закрыть форму обратной связи',
            template            : 'marginless',
            templateContent     : 'progress'
        };

        const popupProgress = new Popup(popupOptions);

        popupProgress.init();
    }
};

initProgressPopup(progressPopupBtn);

observer.subscribe('loadProgress', (reportList, reportsLoaded) => {
    const allProgressPopupBtn = Array.from(reportList.querySelectorAll('.j-progress-popup'));
    const loadedProgressPopupBtn = allProgressPopupBtn.slice(allProgressPopupBtn.length - reportsLoaded);

    initProgressPopup(loadedProgressPopupBtn);
});

// eslint-disable-next-line no-warning-comments
// todo отрефакторить
const progressListClass = '.j-progress-list';
const progressList = document.querySelector(progressListClass);

const progressMore = document.querySelector('.j-progress-more-btn');

const options = {
    button            : progressMore,
    listWrapper       : progressList,
    itemClass         : '.progress__article',
    nodesAfterLastItem: 1,
    url               : '/api/progress/'
};

if (progressList) {
    const loadBtnCount = 1;

    observer.publish('loadProgress', progressList, progressList.childElementCount - loadBtnCount);
}

if (progressMore) {
    new ShowMore(options).init();
}

// video controls
observer.subscribe('createPopup', (popup) => {
    const onlinePopup = popup.querySelector('.j-online-popup');

    if (onlinePopup) {
        const videoControls = new PopupVideoControls(onlinePopup);

        videoControls.init();
    }
});

// video popup
const videoPopupBtn = Array.from(document.querySelectorAll('.j-progress-popup-video'));

const initVideoPopup = (buttons) => {
    if (buttons) {
        const popupOptions = {
            openButtons         : buttons,
            closeButtonAriaLabel: 'Закрыть попап',
            template            : 'marginless',
            loadAfterOpen       : true
        };

        const popupProgress = new Popup(popupOptions);

        popupProgress.init();
    }
};

initVideoPopup(videoPopupBtn);
